/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createChainClass } from '../../factoriesAny.js';
export var ChainDependencies = {
  typedDependencies,
  createChainClass
};